// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"C5-z","trustedRetailerTooltipWrapper":"D5-z"};